/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as Thermometer } from '../../assets/svg/thermometer.svg';
export default Thermometer;
